module.exports = "/images/vendor/desiigner-svg/svg/social/twitter.svg?69628abffd8087bc2d42076b7299c71a";